import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-homepage-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TileComponent {
  @Input() type = 's';
  @Input() title: string;
  @Input() linkPath: string;
  @Input() linkText: string;
  @Input() custom = false;
  private readonly classesByType = {
    s: 'homepage-tile-s col-lg-4',
    m: 'homepage-tile-m col-lg-8',
    l: 'homepage-tile-l col-lg-12'
  };
  private _class = '';

  get class(): string {
    return `homepage-tile ${this._class} ${this.classesByType[this.type]}`;
  }

  @HostBinding()
  @Input()
  set class(v: string) {
    this._class = v;
  }
}
